
import axios from "axios";
import { LOGIN } from "../constants/RoutesUrl";
import { authorize } from "../shared/authorize";
import { api, apiAdmin } from "./api";
import { toast } from 'react-toastify';
import { adminBaseURL, FeedPostApi, FollowApi } from "../constants/API";
import { getToken } from "../shared/token";


export const fetchFeedData = async ({ feedType }) => {
    const user_id = JSON.parse(localStorage.getItem('SignupData'))?.data?.id;
    const signupData = JSON.parse(localStorage.getItem("SignupData"));
    const { data } = signupData;

    try {
        const response = await apiAdmin.post(
            `user/web/home`,
            { user_id, type: feedType }, {
            headers: {
                Authorization: `Bearer ${data.token}`,
            },
        });


        if (response.data?.status === false && response.data?.action === "Unauthenticated request") {
            localStorage.clear();
            sessionStorage.clear();
            window.location.replace("/");
            return;
        }

        // Save subscription data from splash API response
        if (response.data?.active_subscription || response.data?.benefits) {
            const updatedSignupData = {
                ...signupData,
                active_subscription: response.data.active_subscription || signupData.active_subscription,
                benefits: response.data.benefits || signupData.benefits
            };
            localStorage.setItem('SignupData', JSON.stringify(updatedSignupData));
            sessionStorage.setItem('SignupData', JSON.stringify(updatedSignupData));
        }

        return response.data;
    } catch (error) {
        toast.error('Error fetching feed data:', error);
        throw error;
    }
};
export const fetchFeedPostData = async ({ feedType, pageParam = 1 }) => {
    const response = await axios.get(`${FeedPostApi + feedType}?page=${pageParam}`, {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
        },
    });
    return response.data;
};
export const reactToPostApi = async ({ post_id, reaction_type = "like" }) => {
    try {
        const response = await apiAdmin.get(`user/post/reaction/${post_id}/${reaction_type}`, authorize());
        return response.data;
    } catch (error) {
        toast.error('Error reacting to post:', error);
        throw error;
    }
};

export const likePostApi = async ({ post_id, reaction_type = "like" }) => {
    try {
        const response = await apiAdmin.get(`user/post/reaction/${post_id}/${reaction_type}`, authorize());
        return response.data;
    } catch (error) {
        toast.error('Error reacting to post:', error);
        throw error;
    }
};

export const savePostApi = async ({ post_id }) => {
    const user_id = JSON.parse(localStorage.getItem('SignupData'))?.data?.id;
    try {
        const response = await apiAdmin.get(`user/post/save/${post_id}`, authorize());
        return response.data;
    } catch (error) {
        toast.error('Error fetching feed data:', error);
        throw error;
    }
};

export const repostPostApi = async ({ post_id }) => {
    try {
        const response = await apiAdmin.get(`user/post/repost/${post_id}`, authorize());
        return response.data;
    } catch (error) {
        toast.error('Error fetching feed data:', error);
        throw error;
    }
}

export const usersLikedPostApi = async ({ post_id, page }) => {
    try {
        const response = await apiAdmin.get(`user/post/likes/${post_id}?page=${page}`, authorize());
        return response.data;
    } catch (error) {
        toast.error('Error fetching liked users data:', error);
        throw error;
    }
}

export const reserveWebinarApi = async ({ post_id }) => {
    try {
        const response = await apiAdmin.get(`user/post/reserve/${post_id}`, authorize());
        return response.data;
    } catch (error) {
        toast.error('Error fetching reserve webinar data:', error);
        throw error;
    }
}

export const followUserApi = async (id) => {
    try {
        const response = await axios.get(`${FollowApi}${id}`, authorize());
        return response.data;
    } catch (error) {
        toast.error('Something went Wrong', error);
        throw error;
    }
}

